import { sessionStore } from '@/lib/storage'

export type PromptName = 'location' | 'install'

const KEY = 'angadi.prompted'

/** Start-up prompts already shown in this visit (D-65): each shows once per visit, until done. */
export function seenThisVisit(): Set<PromptName> {
  try {
    return new Set(JSON.parse(sessionStore.get(KEY) ?? '[]') as PromptName[])
  } catch {
    return new Set()
  }
}

export function markSeen(name: PromptName): void {
  const seen = seenThisVisit()
  seen.add(name)
  sessionStore.set(KEY, JSON.stringify([...seen]))
}
